// Policies names
export const SIGN_UP_SIGN_IN_POLICY = "B2C_1_susi_staff_app";
export const FORGOT_PASSWORD_POLICY = "B2C_1_pwd_reset";
export const EDIT_PROFILE_POLICY = "B2C_1_editprofile_staff_app ";

// Names and id's for the app and the tenant
export const TENANT_NAME = "Loyalty Logistix";
export const CLIENT_ID = "c6b7dd7c-30f3-41a6-a090-03e9ded71755";
export const TENANT_ID = "3a13b303-7732-4843-bf8e-0f8dd7fe3a9a";
